// Footer.jsx
import React from "react";

const Footer = () => (
    <footer className="bg-white text-gray-600 py-3 px-6 text-center text-xs border-t border-gray-200 w-full mt-auto">
        <p>
            &copy; {new Date().getFullYear()} <strong>AutoRAT Portal</strong>
        </p>
        <p className="mt-1">
            Automation Execution Report.{" "}
            <a href="mailto:michealgurunath@gmail.com" className="text-purple-600 hover:underline">
                michealgurunath@gmail.com
            </a>
        </p>
    </footer>
);

export default Footer;
